// "How Bailey talks": a feel to start from, stored at the front of the
// free-text greeting the prompt already reads ("Warm and chatty. Mention
// we're dog-friendly"), so nothing on the server had to change.
export const TONES = [
    { id: 'warm', label: 'Warm and chatty', line: 'Friendly, first names, a little small talk' },
    { id: 'calm', label: 'Calm and professional', line: 'Polished and reassuring' },
    { id: 'brief', label: 'Short and to the point', line: 'Gets clients booked, fast' },
    { id: 'fun', label: 'Fun and playful', line: 'Light, a bit cheeky, still helpful' }
];
export const splitGreeting = (text) => {
    const t = String(text || '');
    const tone = TONES.find((x) => t === x.label || t.startsWith(`${x.label}. `) || t.startsWith(`${x.label}.`));
    if (!tone) return { tone: '', notes: t };
    return { tone: tone.id, notes: t.slice(tone.label.length).replace(/^\.\s*/, '') };
};
export const joinGreeting = (toneId, notes) => {
    const tone = TONES.find((x) => x.id === toneId);
    const rest = String(notes || '').trim();
    if (!tone) return rest;
    return rest ? `${tone.label}. ${rest}` : tone.label;
};

// "How that sounds": one client question, answered in each feel, so an owner
// hears the difference before choosing. Plain words; stylists are made up.
export const EXAMPLE_ASK = 'Hi, have you got anything Saturday for a cut and colour?';
export const EXAMPLES = {
    warm: 'Hiya, lovely to hear from you! Saturday’s getting busy, but I’ve got 10:30 with Sam or 2pm with Alex. Shall I pop you in for one of those?',
    calm: 'Good afternoon. For a cut and colour on Saturday I can offer 10:30am with Sam or 2:00pm with Alex. Would you like me to book one of those for you?',
    brief: 'Saturday: 10:30 with Sam or 2pm with Alex. Which suits?',
    fun: 'Ooh, a Saturday glow-up, love that! I can squeeze you in at 10:30 with Sam or 2pm with Alex. Which one’s calling your name?',
    '': 'Hi! On Saturday I’ve got 10:30 with Sam or 2pm with Alex. Would either of those work for you?'
};
